import React from "react";

const navLinks = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#2B211A] text-[#D6CDBB] pt-24 pb-10 relative overflow-hidden">
      <div className="grain" />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid lg:grid-cols-12 gap-12 pb-16 border-b border-[#6B5343]/50">
          <div className="lg:col-span-5">
            <div className="font-serif-display text-4xl md:text-5xl text-[#F9F8F6] leading-[1.05]">
              Dira Yanuar Rusdias <span className="text-[#B89A7E]">LLC</span>
            </div>
            <p className="mt-6 max-w-md text-[#D6CDBB]/80 font-light leading-relaxed">
              An unbiased, fee-for-service cross-border property consultancy serving international owners
              of prime urban residential assets.
            </p>

            <div className="mt-8 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.28em] text-[#B89A7E]">
              <span className="w-8 h-px bg-[#B89A7E]" /> Dira Yanuar Rusdias LLC · United States
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#B89A7E]">Navigate</div>
            <ul className="mt-6 space-y-3">
              {navLinks.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-[#F9F8F6]/90 hover:text-[#B89A7E] transition-colors font-light"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#B89A7E]">Contact</div>
            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href="mailto:office@dira-llc.com"
                  data-testid="footer-email"
                  className="font-serif-display text-2xl text-[#F9F8F6] hover:text-[#B89A7E] transition-colors"
                >
                  office@dira-llc.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+18668031434"
                  data-testid="footer-phone"
                  className="font-serif-display text-xl text-[#F9F8F6] hover:text-[#B89A7E] transition-colors"
                >
                  +1 866 803 1434
                </a>
              </li>
              <li className="text-[#D6CDBB]/80 font-light leading-relaxed">
                30 N Gould St Ste R<br />
                Sheridan, WY 82801<br />
                United States
              </li>
              <li className="text-[#D6CDBB]/60 font-light text-sm">
                Practice anchored in London W1D
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#D6CDBB]/60">
          <div>© {new Date().getFullYear()} Dira Yanuar Rusdias LLC. All rights reserved.</div>
          <div className="uppercase tracking-[0.28em]">
            Independent · Fee-for-Service · No Brokerage
          </div>
        </div>
      </div>
    </footer>
  );
}
